/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../.vite-dev/__root'
import { Route as IndexRouteImport } from './../.vite-dev/index'
import { Route as AccessibilityRouteImport } from './../.vite-dev/accessibility'
import { Route as AutomatedClinicianDevRouteImport } from './../.vite-dev/automated-clinician-dev'
import { Route as AutomatedPatientDevRouteImport } from './../.vite-dev/automated-patient-dev'
import { Route as AxaloginRouteImport } from './../.vite-dev/axalogin'
import { Route as CreateAccountRouteImport } from './../.vite-dev/create-account'
import { Route as EventsTestRouteImport } from './../.vite-dev/events-test'
import { Route as FloatingVideoRouteImport } from './../.vite-dev/floating-video'
import { Route as ForgotPasswordRouteImport } from './../.vite-dev/forgot-password'
import { Route as GdprRouteImport } from './../.vite-dev/gdpr'
import { Route as HbsbvtRouteImport } from './../.vite-dev/hbsbvt'
import { Route as LinkloginRouteImport } from './../.vite-dev/linklogin'
import { Route as LoginRouteImport } from './../.vite-dev/login'
import { Route as PolicyRouteImport } from './../.vite-dev/policy'
import { Route as RegulatoryRouteImport } from './../.vite-dev/regulatory'
import { Route as SurveyRouteImport } from './../.vite-dev/survey'
import { Route as WellbeinghubRouteImport } from './../.vite-dev/wellbeinghub'
import { Route as ClinicianIndexRouteImport } from './../.vite-dev/clinician/index'
import { Route as ClinicianAppointmentsRouteImport } from './../.vite-dev/clinician/appointments'
import { Route as ClinicianAssessmentsRouteImport } from './../.vite-dev/clinician/assessments'
import { Route as ClinicianCasesRouteImport } from './../.vite-dev/clinician/cases'
import { Route as ClinicianChooseRouteImport } from './../.vite-dev/clinician/choose'
import { Route as ClinicianConfirmRouteImport } from './../.vite-dev/clinician/confirm'
import { Route as ClinicianPatientsRouteImport } from './../.vite-dev/clinician/patients'
import { Route as ClinicianProfileRouteImport } from './../.vite-dev/clinician/profile'
import { Route as ClinicianReportsRouteImport } from './../.vite-dev/clinician/reports'
import { Route as ClinicianSessionRouteImport } from './../.vite-dev/clinician/session'
import { Route as ClinicianSupportRouteImport } from './../.vite-dev/clinician/support'
import { Route as ClinicianTimelineRouteImport } from './../.vite-dev/clinician/timeline'
import { Route as ClinicianTimeline360RouteImport } from './../.vite-dev/clinician/timeline360'
import { Route as ConfirmEmailIndexRouteImport } from './../.vite-dev/confirm-email/index'
import { Route as PatientsIndexRouteImport } from './../.vite-dev/patients/index'
import { Route as PatientsAppointmentsRouteImport } from './../.vite-dev/patients/appointments'
import { Route as PatientsAssessmentsRouteImport } from './../.vite-dev/patients/assessments'
import { Route as PatientsChooseRouteImport } from './../.vite-dev/patients/choose'
import { Route as PatientsConfirmRouteImport } from './../.vite-dev/patients/confirm'
import { Route as PatientsDocumentsRouteImport } from './../.vite-dev/patients/documents'
import { Route as PatientsFace2faceRouteImport } from './../.vite-dev/patients/face2face'
import { Route as PatientsLegalRouteImport } from './../.vite-dev/patients/legal'
import { Route as PatientsProfileRouteImport } from './../.vite-dev/patients/profile'
import { Route as PatientsQuestionsRouteImport } from './../.vite-dev/patients/questions'
import { Route as PatientsRegisterRouteImport } from './../.vite-dev/patients/register'
import { Route as PatientsSessionRouteImport } from './../.vite-dev/patients/session'
import { Route as PatientsSupportRouteImport } from './../.vite-dev/patients/support'
import { Route as PatientsTestCallRouteImport } from './../.vite-dev/patients/test-call'
import { Route as PatientsTimelineRouteImport } from './../.vite-dev/patients/timeline'
import { Route as PatientsTodosRouteImport } from './../.vite-dev/patients/todos'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessibilityRoute = AccessibilityRouteImport.update({
  id: '/accessibility',
  path: '/accessibility',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomatedClinicianDevRoute = AutomatedClinicianDevRouteImport.update({
  id: '/automated-clinician-dev',
  path: '/automated-clinician-dev',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomatedPatientDevRoute = AutomatedPatientDevRouteImport.update({
  id: '/automated-patient-dev',
  path: '/automated-patient-dev',
  getParentRoute: () => rootRouteImport,
} as any)
const AxaloginRoute = AxaloginRouteImport.update({
  id: '/axalogin',
  path: '/axalogin',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateAccountRoute = CreateAccountRouteImport.update({
  id: '/create-account',
  path: '/create-account',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsTestRoute = EventsTestRouteImport.update({
  id: '/events-test',
  path: '/events-test',
  getParentRoute: () => rootRouteImport,
} as any)
const FloatingVideoRoute = FloatingVideoRouteImport.update({
  id: '/floating-video',
  path: '/floating-video',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const GdprRoute = GdprRouteImport.update({
  id: '/gdpr',
  path: '/gdpr',
  getParentRoute: () => rootRouteImport,
} as any)
const HbsbvtRoute = HbsbvtRouteImport.update({
  id: '/hbsbvt',
  path: '/hbsbvt',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkloginRoute = LinkloginRouteImport.update({
  id: '/linklogin',
  path: '/linklogin',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PolicyRoute = PolicyRouteImport.update({
  id: '/policy',
  path: '/policy',
  getParentRoute: () => rootRouteImport,
} as any)
const RegulatoryRoute = RegulatoryRouteImport.update({
  id: '/regulatory',
  path: '/regulatory',
  getParentRoute: () => rootRouteImport,
} as any)
const SurveyRoute = SurveyRouteImport.update({
  id: '/survey',
  path: '/survey',
  getParentRoute: () => rootRouteImport,
} as any)
const WellbeinghubRoute = WellbeinghubRouteImport.update({
  id: '/wellbeinghub',
  path: '/wellbeinghub',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianIndexRoute = ClinicianIndexRouteImport.update({
  id: '/clinician/',
  path: '/clinician/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianAppointmentsRoute = ClinicianAppointmentsRouteImport.update({
  id: '/clinician/appointments',
  path: '/clinician/appointments',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianAssessmentsRoute = ClinicianAssessmentsRouteImport.update({
  id: '/clinician/assessments',
  path: '/clinician/assessments',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianCasesRoute = ClinicianCasesRouteImport.update({
  id: '/clinician/cases',
  path: '/clinician/cases',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianChooseRoute = ClinicianChooseRouteImport.update({
  id: '/clinician/choose',
  path: '/clinician/choose',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianConfirmRoute = ClinicianConfirmRouteImport.update({
  id: '/clinician/confirm',
  path: '/clinician/confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianPatientsRoute = ClinicianPatientsRouteImport.update({
  id: '/clinician/patients',
  path: '/clinician/patients',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianProfileRoute = ClinicianProfileRouteImport.update({
  id: '/clinician/profile',
  path: '/clinician/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianReportsRoute = ClinicianReportsRouteImport.update({
  id: '/clinician/reports',
  path: '/clinician/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianSessionRoute = ClinicianSessionRouteImport.update({
  id: '/clinician/session',
  path: '/clinician/session',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianSupportRoute = ClinicianSupportRouteImport.update({
  id: '/clinician/support',
  path: '/clinician/support',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianTimelineRoute = ClinicianTimelineRouteImport.update({
  id: '/clinician/timeline',
  path: '/clinician/timeline',
  getParentRoute: () => rootRouteImport,
} as any)
const ClinicianTimeline360Route = ClinicianTimeline360RouteImport.update({
  id: '/clinician/timeline360',
  path: '/clinician/timeline360',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmEmailIndexRoute = ConfirmEmailIndexRouteImport.update({
  id: '/confirm-email/',
  path: '/confirm-email/',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsIndexRoute = PatientsIndexRouteImport.update({
  id: '/patients/',
  path: '/patients/',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsAppointmentsRoute = PatientsAppointmentsRouteImport.update({
  id: '/patients/appointments',
  path: '/patients/appointments',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsAssessmentsRoute = PatientsAssessmentsRouteImport.update({
  id: '/patients/assessments',
  path: '/patients/assessments',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsChooseRoute = PatientsChooseRouteImport.update({
  id: '/patients/choose',
  path: '/patients/choose',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsConfirmRoute = PatientsConfirmRouteImport.update({
  id: '/patients/confirm',
  path: '/patients/confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsDocumentsRoute = PatientsDocumentsRouteImport.update({
  id: '/patients/documents',
  path: '/patients/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsFace2faceRoute = PatientsFace2faceRouteImport.update({
  id: '/patients/face2face',
  path: '/patients/face2face',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsLegalRoute = PatientsLegalRouteImport.update({
  id: '/patients/legal',
  path: '/patients/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsProfileRoute = PatientsProfileRouteImport.update({
  id: '/patients/profile',
  path: '/patients/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsQuestionsRoute = PatientsQuestionsRouteImport.update({
  id: '/patients/questions',
  path: '/patients/questions',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsRegisterRoute = PatientsRegisterRouteImport.update({
  id: '/patients/register',
  path: '/patients/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsSessionRoute = PatientsSessionRouteImport.update({
  id: '/patients/session',
  path: '/patients/session',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsSupportRoute = PatientsSupportRouteImport.update({
  id: '/patients/support',
  path: '/patients/support',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsTestCallRoute = PatientsTestCallRouteImport.update({
  id: '/patients/test-call',
  path: '/patients/test-call',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsTimelineRoute = PatientsTimelineRouteImport.update({
  id: '/patients/timeline',
  path: '/patients/timeline',
  getParentRoute: () => rootRouteImport,
} as any)
const PatientsTodosRoute = PatientsTodosRouteImport.update({
  id: '/patients/todos',
  path: '/patients/todos',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accessibility': typeof AccessibilityRoute
  '/automated-clinician-dev': typeof AutomatedClinicianDevRoute
  '/automated-patient-dev': typeof AutomatedPatientDevRoute
  '/axalogin': typeof AxaloginRoute
  '/create-account': typeof CreateAccountRoute
  '/events-test': typeof EventsTestRoute
  '/floating-video': typeof FloatingVideoRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/gdpr': typeof GdprRoute
  '/hbsbvt': typeof HbsbvtRoute
  '/linklogin': typeof LinkloginRoute
  '/login': typeof LoginRoute
  '/policy': typeof PolicyRoute
  '/regulatory': typeof RegulatoryRoute
  '/survey': typeof SurveyRoute
  '/wellbeinghub': typeof WellbeinghubRoute
  '/clinician/appointments': typeof ClinicianAppointmentsRoute
  '/clinician/assessments': typeof ClinicianAssessmentsRoute
  '/clinician/cases': typeof ClinicianCasesRoute
  '/clinician/choose': typeof ClinicianChooseRoute
  '/clinician/confirm': typeof ClinicianConfirmRoute
  '/clinician/patients': typeof ClinicianPatientsRoute
  '/clinician/profile': typeof ClinicianProfileRoute
  '/clinician/reports': typeof ClinicianReportsRoute
  '/clinician/session': typeof ClinicianSessionRoute
  '/clinician/support': typeof ClinicianSupportRoute
  '/clinician/timeline': typeof ClinicianTimelineRoute
  '/clinician/timeline360': typeof ClinicianTimeline360Route
  '/patients/appointments': typeof PatientsAppointmentsRoute
  '/patients/assessments': typeof PatientsAssessmentsRoute
  '/patients/choose': typeof PatientsChooseRoute
  '/patients/confirm': typeof PatientsConfirmRoute
  '/patients/documents': typeof PatientsDocumentsRoute
  '/patients/face2face': typeof PatientsFace2faceRoute
  '/patients/legal': typeof PatientsLegalRoute
  '/patients/profile': typeof PatientsProfileRoute
  '/patients/questions': typeof PatientsQuestionsRoute
  '/patients/register': typeof PatientsRegisterRoute
  '/patients/session': typeof PatientsSessionRoute
  '/patients/support': typeof PatientsSupportRoute
  '/patients/test-call': typeof PatientsTestCallRoute
  '/patients/timeline': typeof PatientsTimelineRoute
  '/patients/todos': typeof PatientsTodosRoute
  '/clinician/': typeof ClinicianIndexRoute
  '/confirm-email/': typeof ConfirmEmailIndexRoute
  '/patients/': typeof PatientsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accessibility': typeof AccessibilityRoute
  '/automated-clinician-dev': typeof AutomatedClinicianDevRoute
  '/automated-patient-dev': typeof AutomatedPatientDevRoute
  '/axalogin': typeof AxaloginRoute
  '/create-account': typeof CreateAccountRoute
  '/events-test': typeof EventsTestRoute
  '/floating-video': typeof FloatingVideoRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/gdpr': typeof GdprRoute
  '/hbsbvt': typeof HbsbvtRoute
  '/linklogin': typeof LinkloginRoute
  '/login': typeof LoginRoute
  '/policy': typeof PolicyRoute
  '/regulatory': typeof RegulatoryRoute
  '/survey': typeof SurveyRoute
  '/wellbeinghub': typeof WellbeinghubRoute
  '/clinician/appointments': typeof ClinicianAppointmentsRoute
  '/clinician/assessments': typeof ClinicianAssessmentsRoute
  '/clinician/cases': typeof ClinicianCasesRoute
  '/clinician/choose': typeof ClinicianChooseRoute
  '/clinician/confirm': typeof ClinicianConfirmRoute
  '/clinician/patients': typeof ClinicianPatientsRoute
  '/clinician/profile': typeof ClinicianProfileRoute
  '/clinician/reports': typeof ClinicianReportsRoute
  '/clinician/session': typeof ClinicianSessionRoute
  '/clinician/support': typeof ClinicianSupportRoute
  '/clinician/timeline': typeof ClinicianTimelineRoute
  '/clinician/timeline360': typeof ClinicianTimeline360Route
  '/patients/appointments': typeof PatientsAppointmentsRoute
  '/patients/assessments': typeof PatientsAssessmentsRoute
  '/patients/choose': typeof PatientsChooseRoute
  '/patients/confirm': typeof PatientsConfirmRoute
  '/patients/documents': typeof PatientsDocumentsRoute
  '/patients/face2face': typeof PatientsFace2faceRoute
  '/patients/legal': typeof PatientsLegalRoute
  '/patients/profile': typeof PatientsProfileRoute
  '/patients/questions': typeof PatientsQuestionsRoute
  '/patients/register': typeof PatientsRegisterRoute
  '/patients/session': typeof PatientsSessionRoute
  '/patients/support': typeof PatientsSupportRoute
  '/patients/test-call': typeof PatientsTestCallRoute
  '/patients/timeline': typeof PatientsTimelineRoute
  '/patients/todos': typeof PatientsTodosRoute
  '/clinician': typeof ClinicianIndexRoute
  '/confirm-email': typeof ConfirmEmailIndexRoute
  '/patients': typeof PatientsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accessibility': typeof AccessibilityRoute
  '/automated-clinician-dev': typeof AutomatedClinicianDevRoute
  '/automated-patient-dev': typeof AutomatedPatientDevRoute
  '/axalogin': typeof AxaloginRoute
  '/create-account': typeof CreateAccountRoute
  '/events-test': typeof EventsTestRoute
  '/floating-video': typeof FloatingVideoRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/gdpr': typeof GdprRoute
  '/hbsbvt': typeof HbsbvtRoute
  '/linklogin': typeof LinkloginRoute
  '/login': typeof LoginRoute
  '/policy': typeof PolicyRoute
  '/regulatory': typeof RegulatoryRoute
  '/survey': typeof SurveyRoute
  '/wellbeinghub': typeof WellbeinghubRoute
  '/clinician/appointments': typeof ClinicianAppointmentsRoute
  '/clinician/assessments': typeof ClinicianAssessmentsRoute
  '/clinician/cases': typeof ClinicianCasesRoute
  '/clinician/choose': typeof ClinicianChooseRoute
  '/clinician/confirm': typeof ClinicianConfirmRoute
  '/clinician/patients': typeof ClinicianPatientsRoute
  '/clinician/profile': typeof ClinicianProfileRoute
  '/clinician/reports': typeof ClinicianReportsRoute
  '/clinician/session': typeof ClinicianSessionRoute
  '/clinician/support': typeof ClinicianSupportRoute
  '/clinician/timeline': typeof ClinicianTimelineRoute
  '/clinician/timeline360': typeof ClinicianTimeline360Route
  '/patients/appointments': typeof PatientsAppointmentsRoute
  '/patients/assessments': typeof PatientsAssessmentsRoute
  '/patients/choose': typeof PatientsChooseRoute
  '/patients/confirm': typeof PatientsConfirmRoute
  '/patients/documents': typeof PatientsDocumentsRoute
  '/patients/face2face': typeof PatientsFace2faceRoute
  '/patients/legal': typeof PatientsLegalRoute
  '/patients/profile': typeof PatientsProfileRoute
  '/patients/questions': typeof PatientsQuestionsRoute
  '/patients/register': typeof PatientsRegisterRoute
  '/patients/session': typeof PatientsSessionRoute
  '/patients/support': typeof PatientsSupportRoute
  '/patients/test-call': typeof PatientsTestCallRoute
  '/patients/timeline': typeof PatientsTimelineRoute
  '/patients/todos': typeof PatientsTodosRoute
  '/clinician/': typeof ClinicianIndexRoute
  '/confirm-email/': typeof ConfirmEmailIndexRoute
  '/patients/': typeof PatientsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accessibility'
    | '/automated-clinician-dev'
    | '/automated-patient-dev'
    | '/axalogin'
    | '/create-account'
    | '/events-test'
    | '/floating-video'
    | '/forgot-password'
    | '/gdpr'
    | '/hbsbvt'
    | '/linklogin'
    | '/login'
    | '/policy'
    | '/regulatory'
    | '/survey'
    | '/wellbeinghub'
    | '/clinician/appointments'
    | '/clinician/assessments'
    | '/clinician/cases'
    | '/clinician/choose'
    | '/clinician/confirm'
    | '/clinician/patients'
    | '/clinician/profile'
    | '/clinician/reports'
    | '/clinician/session'
    | '/clinician/support'
    | '/clinician/timeline'
    | '/clinician/timeline360'
    | '/patients/appointments'
    | '/patients/assessments'
    | '/patients/choose'
    | '/patients/confirm'
    | '/patients/documents'
    | '/patients/face2face'
    | '/patients/legal'
    | '/patients/profile'
    | '/patients/questions'
    | '/patients/register'
    | '/patients/session'
    | '/patients/support'
    | '/patients/test-call'
    | '/patients/timeline'
    | '/patients/todos'
    | '/clinician/'
    | '/confirm-email/'
    | '/patients/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accessibility'
    | '/automated-clinician-dev'
    | '/automated-patient-dev'
    | '/axalogin'
    | '/create-account'
    | '/events-test'
    | '/floating-video'
    | '/forgot-password'
    | '/gdpr'
    | '/hbsbvt'
    | '/linklogin'
    | '/login'
    | '/policy'
    | '/regulatory'
    | '/survey'
    | '/wellbeinghub'
    | '/clinician/appointments'
    | '/clinician/assessments'
    | '/clinician/cases'
    | '/clinician/choose'
    | '/clinician/confirm'
    | '/clinician/patients'
    | '/clinician/profile'
    | '/clinician/reports'
    | '/clinician/session'
    | '/clinician/support'
    | '/clinician/timeline'
    | '/clinician/timeline360'
    | '/patients/appointments'
    | '/patients/assessments'
    | '/patients/choose'
    | '/patients/confirm'
    | '/patients/documents'
    | '/patients/face2face'
    | '/patients/legal'
    | '/patients/profile'
    | '/patients/questions'
    | '/patients/register'
    | '/patients/session'
    | '/patients/support'
    | '/patients/test-call'
    | '/patients/timeline'
    | '/patients/todos'
    | '/clinician'
    | '/confirm-email'
    | '/patients'
  id:
    | '__root__'
    | '/'
    | '/accessibility'
    | '/automated-clinician-dev'
    | '/automated-patient-dev'
    | '/axalogin'
    | '/create-account'
    | '/events-test'
    | '/floating-video'
    | '/forgot-password'
    | '/gdpr'
    | '/hbsbvt'
    | '/linklogin'
    | '/login'
    | '/policy'
    | '/regulatory'
    | '/survey'
    | '/wellbeinghub'
    | '/clinician/appointments'
    | '/clinician/assessments'
    | '/clinician/cases'
    | '/clinician/choose'
    | '/clinician/confirm'
    | '/clinician/patients'
    | '/clinician/profile'
    | '/clinician/reports'
    | '/clinician/session'
    | '/clinician/support'
    | '/clinician/timeline'
    | '/clinician/timeline360'
    | '/patients/appointments'
    | '/patients/assessments'
    | '/patients/choose'
    | '/patients/confirm'
    | '/patients/documents'
    | '/patients/face2face'
    | '/patients/legal'
    | '/patients/profile'
    | '/patients/questions'
    | '/patients/register'
    | '/patients/session'
    | '/patients/support'
    | '/patients/test-call'
    | '/patients/timeline'
    | '/patients/todos'
    | '/clinician/'
    | '/confirm-email/'
    | '/patients/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccessibilityRoute: typeof AccessibilityRoute
  AutomatedClinicianDevRoute: typeof AutomatedClinicianDevRoute
  AutomatedPatientDevRoute: typeof AutomatedPatientDevRoute
  AxaloginRoute: typeof AxaloginRoute
  CreateAccountRoute: typeof CreateAccountRoute
  EventsTestRoute: typeof EventsTestRoute
  FloatingVideoRoute: typeof FloatingVideoRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  GdprRoute: typeof GdprRoute
  HbsbvtRoute: typeof HbsbvtRoute
  LinkloginRoute: typeof LinkloginRoute
  LoginRoute: typeof LoginRoute
  PolicyRoute: typeof PolicyRoute
  RegulatoryRoute: typeof RegulatoryRoute
  SurveyRoute: typeof SurveyRoute
  WellbeinghubRoute: typeof WellbeinghubRoute
  ClinicianAppointmentsRoute: typeof ClinicianAppointmentsRoute
  ClinicianAssessmentsRoute: typeof ClinicianAssessmentsRoute
  ClinicianCasesRoute: typeof ClinicianCasesRoute
  ClinicianChooseRoute: typeof ClinicianChooseRoute
  ClinicianConfirmRoute: typeof ClinicianConfirmRoute
  ClinicianPatientsRoute: typeof ClinicianPatientsRoute
  ClinicianProfileRoute: typeof ClinicianProfileRoute
  ClinicianReportsRoute: typeof ClinicianReportsRoute
  ClinicianSessionRoute: typeof ClinicianSessionRoute
  ClinicianSupportRoute: typeof ClinicianSupportRoute
  ClinicianTimelineRoute: typeof ClinicianTimelineRoute
  ClinicianTimeline360Route: typeof ClinicianTimeline360Route
  PatientsAppointmentsRoute: typeof PatientsAppointmentsRoute
  PatientsAssessmentsRoute: typeof PatientsAssessmentsRoute
  PatientsChooseRoute: typeof PatientsChooseRoute
  PatientsConfirmRoute: typeof PatientsConfirmRoute
  PatientsDocumentsRoute: typeof PatientsDocumentsRoute
  PatientsFace2faceRoute: typeof PatientsFace2faceRoute
  PatientsLegalRoute: typeof PatientsLegalRoute
  PatientsProfileRoute: typeof PatientsProfileRoute
  PatientsQuestionsRoute: typeof PatientsQuestionsRoute
  PatientsRegisterRoute: typeof PatientsRegisterRoute
  PatientsSessionRoute: typeof PatientsSessionRoute
  PatientsSupportRoute: typeof PatientsSupportRoute
  PatientsTestCallRoute: typeof PatientsTestCallRoute
  PatientsTimelineRoute: typeof PatientsTimelineRoute
  PatientsTodosRoute: typeof PatientsTodosRoute
  ClinicianIndexRoute: typeof ClinicianIndexRoute
  ConfirmEmailIndexRoute: typeof ConfirmEmailIndexRoute
  PatientsIndexRoute: typeof PatientsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accessibility': {
      id: '/accessibility'
      path: '/accessibility'
      fullPath: '/accessibility'
      preLoaderRoute: typeof AccessibilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automated-clinician-dev': {
      id: '/automated-clinician-dev'
      path: '/automated-clinician-dev'
      fullPath: '/automated-clinician-dev'
      preLoaderRoute: typeof AutomatedClinicianDevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automated-patient-dev': {
      id: '/automated-patient-dev'
      path: '/automated-patient-dev'
      fullPath: '/automated-patient-dev'
      preLoaderRoute: typeof AutomatedPatientDevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/axalogin': {
      id: '/axalogin'
      path: '/axalogin'
      fullPath: '/axalogin'
      preLoaderRoute: typeof AxaloginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create-account': {
      id: '/create-account'
      path: '/create-account'
      fullPath: '/create-account'
      preLoaderRoute: typeof CreateAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events-test': {
      id: '/events-test'
      path: '/events-test'
      fullPath: '/events-test'
      preLoaderRoute: typeof EventsTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/floating-video': {
      id: '/floating-video'
      path: '/floating-video'
      fullPath: '/floating-video'
      preLoaderRoute: typeof FloatingVideoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gdpr': {
      id: '/gdpr'
      path: '/gdpr'
      fullPath: '/gdpr'
      preLoaderRoute: typeof GdprRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hbsbvt': {
      id: '/hbsbvt'
      path: '/hbsbvt'
      fullPath: '/hbsbvt'
      preLoaderRoute: typeof HbsbvtRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/linklogin': {
      id: '/linklogin'
      path: '/linklogin'
      fullPath: '/linklogin'
      preLoaderRoute: typeof LinkloginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policy': {
      id: '/policy'
      path: '/policy'
      fullPath: '/policy'
      preLoaderRoute: typeof PolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/regulatory': {
      id: '/regulatory'
      path: '/regulatory'
      fullPath: '/regulatory'
      preLoaderRoute: typeof RegulatoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/survey': {
      id: '/survey'
      path: '/survey'
      fullPath: '/survey'
      preLoaderRoute: typeof SurveyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wellbeinghub': {
      id: '/wellbeinghub'
      path: '/wellbeinghub'
      fullPath: '/wellbeinghub'
      preLoaderRoute: typeof WellbeinghubRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/': {
      id: '/clinician/'
      path: '/clinician'
      fullPath: '/clinician/'
      preLoaderRoute: typeof ClinicianIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/appointments': {
      id: '/clinician/appointments'
      path: '/clinician/appointments'
      fullPath: '/clinician/appointments'
      preLoaderRoute: typeof ClinicianAppointmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/assessments': {
      id: '/clinician/assessments'
      path: '/clinician/assessments'
      fullPath: '/clinician/assessments'
      preLoaderRoute: typeof ClinicianAssessmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/cases': {
      id: '/clinician/cases'
      path: '/clinician/cases'
      fullPath: '/clinician/cases'
      preLoaderRoute: typeof ClinicianCasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/choose': {
      id: '/clinician/choose'
      path: '/clinician/choose'
      fullPath: '/clinician/choose'
      preLoaderRoute: typeof ClinicianChooseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/confirm': {
      id: '/clinician/confirm'
      path: '/clinician/confirm'
      fullPath: '/clinician/confirm'
      preLoaderRoute: typeof ClinicianConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/patients': {
      id: '/clinician/patients'
      path: '/clinician/patients'
      fullPath: '/clinician/patients'
      preLoaderRoute: typeof ClinicianPatientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/profile': {
      id: '/clinician/profile'
      path: '/clinician/profile'
      fullPath: '/clinician/profile'
      preLoaderRoute: typeof ClinicianProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/reports': {
      id: '/clinician/reports'
      path: '/clinician/reports'
      fullPath: '/clinician/reports'
      preLoaderRoute: typeof ClinicianReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/session': {
      id: '/clinician/session'
      path: '/clinician/session'
      fullPath: '/clinician/session'
      preLoaderRoute: typeof ClinicianSessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/support': {
      id: '/clinician/support'
      path: '/clinician/support'
      fullPath: '/clinician/support'
      preLoaderRoute: typeof ClinicianSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/timeline': {
      id: '/clinician/timeline'
      path: '/clinician/timeline'
      fullPath: '/clinician/timeline'
      preLoaderRoute: typeof ClinicianTimelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clinician/timeline360': {
      id: '/clinician/timeline360'
      path: '/clinician/timeline360'
      fullPath: '/clinician/timeline360'
      preLoaderRoute: typeof ClinicianTimeline360RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm-email/': {
      id: '/confirm-email/'
      path: '/confirm-email'
      fullPath: '/confirm-email/'
      preLoaderRoute: typeof ConfirmEmailIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/': {
      id: '/patients/'
      path: '/patients'
      fullPath: '/patients/'
      preLoaderRoute: typeof PatientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/appointments': {
      id: '/patients/appointments'
      path: '/patients/appointments'
      fullPath: '/patients/appointments'
      preLoaderRoute: typeof PatientsAppointmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/assessments': {
      id: '/patients/assessments'
      path: '/patients/assessments'
      fullPath: '/patients/assessments'
      preLoaderRoute: typeof PatientsAssessmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/choose': {
      id: '/patients/choose'
      path: '/patients/choose'
      fullPath: '/patients/choose'
      preLoaderRoute: typeof PatientsChooseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/confirm': {
      id: '/patients/confirm'
      path: '/patients/confirm'
      fullPath: '/patients/confirm'
      preLoaderRoute: typeof PatientsConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/documents': {
      id: '/patients/documents'
      path: '/patients/documents'
      fullPath: '/patients/documents'
      preLoaderRoute: typeof PatientsDocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/face2face': {
      id: '/patients/face2face'
      path: '/patients/face2face'
      fullPath: '/patients/face2face'
      preLoaderRoute: typeof PatientsFace2faceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/legal': {
      id: '/patients/legal'
      path: '/patients/legal'
      fullPath: '/patients/legal'
      preLoaderRoute: typeof PatientsLegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/profile': {
      id: '/patients/profile'
      path: '/patients/profile'
      fullPath: '/patients/profile'
      preLoaderRoute: typeof PatientsProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/questions': {
      id: '/patients/questions'
      path: '/patients/questions'
      fullPath: '/patients/questions'
      preLoaderRoute: typeof PatientsQuestionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/register': {
      id: '/patients/register'
      path: '/patients/register'
      fullPath: '/patients/register'
      preLoaderRoute: typeof PatientsRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/session': {
      id: '/patients/session'
      path: '/patients/session'
      fullPath: '/patients/session'
      preLoaderRoute: typeof PatientsSessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/support': {
      id: '/patients/support'
      path: '/patients/support'
      fullPath: '/patients/support'
      preLoaderRoute: typeof PatientsSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/test-call': {
      id: '/patients/test-call'
      path: '/patients/test-call'
      fullPath: '/patients/test-call'
      preLoaderRoute: typeof PatientsTestCallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/timeline': {
      id: '/patients/timeline'
      path: '/patients/timeline'
      fullPath: '/patients/timeline'
      preLoaderRoute: typeof PatientsTimelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/patients/todos': {
      id: '/patients/todos'
      path: '/patients/todos'
      fullPath: '/patients/todos'
      preLoaderRoute: typeof PatientsTodosRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccessibilityRoute: AccessibilityRoute,
  AutomatedClinicianDevRoute: AutomatedClinicianDevRoute,
  AutomatedPatientDevRoute: AutomatedPatientDevRoute,
  AxaloginRoute: AxaloginRoute,
  CreateAccountRoute: CreateAccountRoute,
  EventsTestRoute: EventsTestRoute,
  FloatingVideoRoute: FloatingVideoRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  GdprRoute: GdprRoute,
  HbsbvtRoute: HbsbvtRoute,
  LinkloginRoute: LinkloginRoute,
  LoginRoute: LoginRoute,
  PolicyRoute: PolicyRoute,
  RegulatoryRoute: RegulatoryRoute,
  SurveyRoute: SurveyRoute,
  WellbeinghubRoute: WellbeinghubRoute,
  ClinicianAppointmentsRoute: ClinicianAppointmentsRoute,
  ClinicianAssessmentsRoute: ClinicianAssessmentsRoute,
  ClinicianCasesRoute: ClinicianCasesRoute,
  ClinicianChooseRoute: ClinicianChooseRoute,
  ClinicianConfirmRoute: ClinicianConfirmRoute,
  ClinicianPatientsRoute: ClinicianPatientsRoute,
  ClinicianProfileRoute: ClinicianProfileRoute,
  ClinicianReportsRoute: ClinicianReportsRoute,
  ClinicianSessionRoute: ClinicianSessionRoute,
  ClinicianSupportRoute: ClinicianSupportRoute,
  ClinicianTimelineRoute: ClinicianTimelineRoute,
  ClinicianTimeline360Route: ClinicianTimeline360Route,
  PatientsAppointmentsRoute: PatientsAppointmentsRoute,
  PatientsAssessmentsRoute: PatientsAssessmentsRoute,
  PatientsChooseRoute: PatientsChooseRoute,
  PatientsConfirmRoute: PatientsConfirmRoute,
  PatientsDocumentsRoute: PatientsDocumentsRoute,
  PatientsFace2faceRoute: PatientsFace2faceRoute,
  PatientsLegalRoute: PatientsLegalRoute,
  PatientsProfileRoute: PatientsProfileRoute,
  PatientsQuestionsRoute: PatientsQuestionsRoute,
  PatientsRegisterRoute: PatientsRegisterRoute,
  PatientsSessionRoute: PatientsSessionRoute,
  PatientsSupportRoute: PatientsSupportRoute,
  PatientsTestCallRoute: PatientsTestCallRoute,
  PatientsTimelineRoute: PatientsTimelineRoute,
  PatientsTodosRoute: PatientsTodosRoute,
  ClinicianIndexRoute: ClinicianIndexRoute,
  ConfirmEmailIndexRoute: ConfirmEmailIndexRoute,
  PatientsIndexRoute: PatientsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
